import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import css from "./css/style.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  css,
  render: h => h(App)
}).$mount("#app");
